import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WebApiPagedCollectionResult, mapCollection } from '@mango/core';

@Injectable()
export class DashboardService {

    constructor(private http: HttpClient) {

    }

    getExample(): Observable<any[]> {
        return this.http.get<WebApiPagedCollectionResult<any>>('/api/dto/deur/get?select=Count(Id),Type&groupBy=Type&orderBy=2').pipe(mapCollection());
    }
}